module.exports = __webpack_public_path__ + "static/media/image_17.a90bf981.jpg";